import { Icon } from "@blueprintjs/core"
import CustomDialog from "components/Atoms/CustomDialog"
import InfoTable from "components/Organisms/table/InfoTable"
import { useSellableItemsDetailLazyQuery } from "generated/graphql"
import React, { useEffect, useState } from "react"

interface SellableItemPreviewProps {
  id: string
  name: string
}
const SellableItemPreview = ({ id }: SellableItemPreviewProps) => {
  const [isOpen, setOpen] = useState(false)
  const [getData, { data }] = useSellableItemsDetailLazyQuery()
  useEffect(() => {
    if (isOpen && parseInt(id)) getData({ variables: { id } })
  }, [isOpen, id, getData])

  const item = data?.sellableItemDetail

  return (
    <>
      <Icon
        icon="info-sign"
        style={{ cursor: "pointer", marginTop: 3, marginRight: 3 }}
        onClick={e => parseInt(id) && setOpen(true)}
      />
      <CustomDialog
        isOpen={isOpen}
        onClose={e => setOpen(false)}
        icon="shopping-cart"
        light
        title="Sellable Item"
      >
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-2">
            <img
              src={item?.primaryPhoto.url}
              alt={item?.name}
              height="100%"
              width="100%"
            />
          </div>
          <div className="col-span-10">
            <span className="vt-styled-link-text">{item?.name}</span>
            <p className="mt-2 text-sm vt-muted">{item?.shortDescription}</p>
          </div>
        </div>
        <div className="mt-3">
          <InfoTable
            data={item?.sellableVarieties ?? []}
            columns={[
              {
                header: "Crop",
                accessor: "variety",
                Cell({ value }) {
                  return `${value?.commodity.name} (${value?.name})`
                },
              },
              {
                header: "Sku Count",
                accessor: "skuType",
                Cell({ value, original }) {
                  return `${original?.skuCount} ${value?.name}`
                },
              },
              {
                header: "Uom Count",
                accessor: "uomType",
                Cell({ value, original }) {
                  return `${original?.uomCount} ${value?.codename}`
                },
              },
            ]}
          />
        </div>
      </CustomDialog>
    </>
  )
}

export default SellableItemPreview
